import EngageRequest from "../../../../services/EngageRequest";
import { $stateParams } from "../../../../router";
import { initTranslation } from "../../../../services/Translate";

const getStateParams = () => {
  return {
    account_uuid: $stateParams.account_uuid,
    contact_uuid: $stateParams.contact_uuid,
    event_id: $stateParams.event_id,
  };
};

export const DataService = {
  get: (_params = {}) => {
    const account_uuid = _params.account_uuid
      ? _params.account_uuid
      : $stateParams.account_uuid;
    const contact_uuid = _params.contact_uuid
      ? _params.contact_uuid
      : $stateParams.contact_uuid;
    const event_id = _params.event_id
      ? _params.event_id
      : $stateParams.event_id;

    return EngageRequest.get(
      `/stream/${account_uuid}/${contact_uuid}/${event_id}`
    ).then((data) => {
      const preferred_langague = data.contact
        ? data.contact.preferred_language
        : "en";
      return initTranslation(preferred_langague).then(() => data);
    });
  },

  streamMessages: () => {
    const { account_uuid, contact_uuid, event_id } = getStateParams();
    return EngageRequest.get(
      `/event-stream-messages/${account_uuid}/${contact_uuid}/${event_id}`
    ).then((data) => data.map((record) => JSON.parse(record.message)));
  },
  saveStreamMessage: (message) => {
    const { account_uuid, contact_uuid, event_id } = getStateParams();
    return EngageRequest.post(
      `/event-stream-messages/${account_uuid}/${contact_uuid}/${event_id}`,
      { message }
    );
  },
  deleteStreamMessage: (message_id) => {
    const { account_uuid, contact_uuid, event_id } = getStateParams();
    return EngageRequest.delete(
      `/event-stream-messages/${account_uuid}/${contact_uuid}/${event_id}/${message_id}`
    );
  },
};

export default DataService;
